import { Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import useSWR from "swr";
import { fetcher } from "@/lib/api";
import { fmtNum } from "@/lib/format";

function fillMinutes(points, hours) {
  const map = new Map(points.map((p) => [new Date(p.minute).getTime(), p]));
  const end = Math.floor(Date.now() / 60000) * 60000;
  const out = [];
  for (let t = end - hours * 3600000; t <= end; t += 60000) {
    const p = map.get(t);
    out.push({ t, live: p?.live_rows || 0, export: p?.export_rows || 0 });
  }
  return out;
}

export function ReceivedChart({ deviceId, hours = 3 }) {
  const { data } = useSWR(`/devices/${deviceId}/minutes?hours=${hours}`, fetcher, { refreshInterval: 30000 });
  const series = fillMinutes(data || [], hours);
  const fmt = (t) => new Date(t).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  return (
    <div className="h-64 w-full" data-testid="received-rows-chart">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={series} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
          <defs>
            <linearGradient id="gLive" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="hsl(var(--chart-1))" stopOpacity={0.35} />
              <stop offset="100%" stopColor="hsl(var(--chart-1))" stopOpacity={0} />
            </linearGradient>
            <linearGradient id="gExp" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="hsl(var(--chart-2))" stopOpacity={0.3} />
              <stop offset="100%" stopColor="hsl(var(--chart-2))" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid vertical={false} stroke="hsl(var(--border))" />
          <XAxis dataKey="t" tickFormatter={fmt} minTickGap={48} tick={{ fontSize: 11, fill: "hsl(var(--muted-foreground))" }} axisLine={false} tickLine={false} />
          <YAxis width={48} tick={{ fontSize: 11, fill: "hsl(var(--muted-foreground))" }} axisLine={false} tickLine={false} tickFormatter={(v) => fmtNum(v)} />
          <Tooltip labelFormatter={fmt} formatter={(v, n) => [fmtNum(v), n === "live" ? "Live rows" : "Export rows"]}
            contentStyle={{ background: "hsl(var(--popover))", border: "1px solid hsl(var(--border))", borderRadius: 12, fontSize: 12 }} />
          <Area type="monotone" dataKey="export" stroke="hsl(var(--chart-2))" fill="url(#gExp)" strokeWidth={1.5} isAnimationActive={false} />
          <Area type="monotone" dataKey="live" stroke="hsl(var(--chart-1))" fill="url(#gLive)" strokeWidth={1.5} isAnimationActive={false} />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
